import _ from 'underscore';

import { resizeNavMobile } from './_nav-mobile.js';
import { handleTicker } from './_ticker.js';

let lastWidth = $(window).width();

$(window).resize(_.debounce(() => {
  const currentWidth = $(window).width();

  resizeNavMobile();

  // only called when the window width changes
  if (currentWidth !== lastWidth) {
    lastWidth = $(window).width();

    // initSmoothScrolling('.carousel-news-events', true);
    handleTicker();
  }
}, 300));